import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';

export default class Organization extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            annualStart: null,
            annualFinish: null,
            annualTaxPercent: 10,
            annualTitle: ''
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/organization/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();

        if (this.isBlank(this.state.annualTaxPercent)) this.state.annualTaxPercent = 0;
        if (this.isBlank(this.state.data.record.currencyRate)) this.state.data.record.currencyRate = 0;

        this.state.annualTaxPercent = parseInt(this.state.annualTaxPercent);
        this.state.data.record.currencyRate = parseInt(this.state.data.record.currencyRate);
        
        this.httpPost("api/v1/organization/save", {
            id: this.getCurrentFormId(),

            annualStart: this.convertMomentToDb(this.state.annualStart),
            annualFinish: this.convertMomentToDb(this.state.annualFinish),
            annualTaxPercent: this.state.annualTaxPercent,
            annualTitle: this.state.annualTitle,

            name: this.state.data.record.name,
            type: this.state.data.record.type,
            nationalId: this.state.data.record.nationalId,
            shomareSabt: this.state.data.record.shomareSabt,
            codeEgtesadi: this.state.data.record.codeEgtesadi,
            warehouseSystem: this.state.data.record.warehouseSystem,
            accountingType: this.state.data.record.accountingType,
            inventoryType: this.state.data.record.inventoryType,

            currencyUnit: this.state.data.record.currencyUnit,
            dateFormat: this.state.data.record.dateFormat,
            taxPercent: this.state.data.record.taxPercent,
            state: this.state.data.record.state,
            city: this.state.data.record.city,
            postalCode: this.state.data.record.postalCode,
            address: this.state.data.record.address,
            tell: this.state.data.record.tell,
            fax: this.state.data.record.fax,
            website: this.state.data.record.website,
            email: this.state.data.record.email,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <div className="container">
            {this.state.data.record.id != this.defaultGuid() && <div className="row mr-t-10">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="panel panel-info center-block mr-t-10">
                        <div className="panel-heading">
                            <span className="panel-title"><strong>حذف کسب و کار</strong></span>
                        </div>
                        <div className="panel-body">
                            <form className="ng-pristine" method="post">
                                <div>
                                    <p>بعد از حذف کسب و کار دسترسی شما به طور کامل از سامانه قطع خواهد شد</p>
                                    <a onClick={e => this.confirmRemove(this.state.data.record.id)} className="hand btn btn-danger text-primary"><span className="fa fa-trash"></span>&nbsp;حذف اطلاعات</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="panel panel-info center-block mr-t-10">
                        <div className="panel-heading">
                            <span className="panel-title"><strong>دانلود اطلاعات</strong></span>
                        </div>
                        <div className="panel-body">
                            <form className="ng-pristine">
                                <div>
                                    <p>از این بخش میتوانید اطلاعات کامل کسب و کار خود را دانلود نمایید.</p>
                                    <a className="btn text-primary" onClick="downloadBox(<?php echo $values->id; ?>)">
                                        <span className="fa fa-download" style={{ "color": "#b4b4b4" }}></span>&nbsp;دانلود
                                    </a>
                                    <div className="modal fade" id="exportDataToExcelModal" tabindex="-1" role="dialog" aria-labelledby="exportDataToExcelModalLabel">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                    <h4 className="modal-title" id="exportDataToExcelModalLabel">
                                                        annual_to_excel
                                                    </h4>
                                                </div>
                                                <form className="ng-pristine ng-valid">
                                                    <div className="modal-body">
                                                        <div className="container-fluid">
                                                            <div className="row mr-t-5">
                                                                <div className="col-sm-12">
                                                                    annual_to_excel_notic
                                                                </div>
                                                            </div>
                                                            <div className="row mr-t-5 ng-hide">
                                                                <div className="col-sm-4  text-left">
                                                                    نام کسب و کار:</div>
                                                                <div className="col-sm-8 text-info"></div>
                                                            </div>
                                                            <div className="row mr-t-5 ng-hide">
                                                                <div className="col-sm-4  text-left">
                                                                    سال مالی:</div>
                                                                <div className="col-sm-8">
                                                                    <div className="btn-group">
                                                                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            انتخاب سال مالی<span className="caret"></span>
                                                                        </button>
                                                                        <ul className="dropdown-menu">
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mr-t-5 ng-hide">
                                                                <div className="col-sm-4 text-left">
                                                                    کلمه عبور:</div>
                                                                <div className="col-sm-8">
                                                                    <input autocomplete="off" className="form-control input-sm ng-pristine ng-untouched ng-valid" type="password" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-default btn-smoke" data-dismiss="modal">انصراف</button>
                                                        <button type="submit" onclick="startDownload()" className="btn btn-success">دانلود</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="panel panel-info center-block mr-t-10">
                        <div className="panel-heading">
                            <span className="panel-title"><strong>بک آپ گیری اطلاعات</strong></span>
                        </div>
                        <div className="panel-body">
                            <form className="ng-pristine">
                                <div>
                                    <p>از این بخش میتوانید بک آپ کامل کسب و کار خود را دانلود نمایید.</p>
                                    <a className="btn text-primary" href="/customer/organizations/download/" download>
                                        <span className="fa fa-download" style={{ "color": "#b4b4b4" }} ></span>&nbsp;دانلود
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="panel panel-info center-block mr-t-10">
                        <div className="panel-heading">
                            <span className="panel-title"><strong>بازیابی اطلاعات</strong></span>
                        </div>
                        <div className="panel-body">
                            <form className="ng-pristine" Method="post" enctype="multipart/form-data">
                                <div>
                                    <p>لطفا فایل بک آپ مورد نظر خود را انتخابب نمایید</p>
                                    <input name="restoreFile" type="file" accept=".acc" style={{ "display": "inline-block" }} />
                                    <button type="submit" className="btn btn-danger" style={{ "float": "left" }}> شروع بازیابی</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>}
            <form method="post" onSubmit={e => this.save(e)} style={{ "marginBottom":"20px"}}>
                <div className="panel panel-info center-block mr-t-10">
                    <div className="panel-heading">
                        {this.state.data.record.id != this.defaultGuid() ?
                            <span className="panel-title"><strong>ویرایش اطلاعات کسب و کار</strong></span>
                            :
                            <span className="panel-title"><strong>راه اندازی کسب و کار جدید</strong></span>
                        }
                    </div>
                    <div className="panel-body">
                        <div className="ng-pristine">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <div className="form-group">
                                    <label for="inputName" className="title1">عنوان کسب و کار <span className="red">*</span></label>
                                    <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="40" placeholder="نام کسب و کار" />
                                </div>
                            </div>
                            {this.state.data.record.id == this.defaultGuid() && <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                <div className="form-group">
                                    <label for="inputType" className="title1">نوع</label>
                                    <select defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)} className="form-control input-sm ng-pristine ng-untouched ng-valid">
                                        <option value="1">حقیقی</option>
                                        <option value="2">حقوقی</option>
                                    </select>
                                </div>
                            </div>}
                            <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                <div className="form-group">
                                    <label for="inputName" className="title1">شناسه/کد ملی <span className="red">*</span></label>
                                    <input defaultValue={this.state.data.record.nationalId} onChange={e => this.state.data.record.nationalId = e.target.value} autocomplete="off" type="text" className="form-control input-sm number ltr" maxlength="11" placeholder="شناسه ملی" /></div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <label for="inputTaxRate" className="input-group-addon">نرخ تبدیل دلار
                                        <span className="red">*</span></label>
                                    <div className="input-group">
                                        <input defaultValue={this.state.data.record.currencyRate} onChange={e => this.state.data.record.currencyRate = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid ltr" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                <div className="form-group">
                                    <label for="inputLegalName" className="title1">شماره ثبت</label>
                                    <input defaultValue={this.state.data.record.shomareSabt} onChange={e => this.state.data.record.shomareSabt = e.target.value} autocomplete="off" type="text" className="form-control input-sm number ltr" maxlength="8" placeholder="شماره ثبت" /></div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                <div className="form-group">
                                    <label className="title1">کد اقتصادی</label>
                                    <input defaultValue={this.state.data.record.codeEgtesadi} onChange={e => this.state.data.record.codeEgtesadi = e.target.value} autocomplete="off" type="text" className="form-control input-sm number ltr" maxlength="14" /></div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12"></div>
                            <div className="clear"></div>
                            <div>
                                <span className="acc-txt-10">
                                    <p className="text-muted"><strong>حسابداری</strong></p>
                                </span>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">سیستم انبار</div>
                                    <select defaultValue={this.state.data.record.warehouseSystem} onChange={e => this.state.data.record.warehouseSystem = parseInt(e.target.value)} className="form-control input-sm">
                                        <option value="1">دارد</option>
                                        <option value="0">نیازی نیست</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 ng-hide">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">سیستم حسابداری</div>
                                    <select defaultValue={this.state.data.record.accountingType} onChange={e => this.state.data.record.accountingType = parseInt(e.target.value)} className="form-control input-sm">
                                        <option value="2">دایمی</option>
                                        <option value="1">ادواری</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 ng-hide">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">نحوه ارزش گذاری</div>
                                    <select defaultValue={this.state.data.record.inventoryType} onChange={e => this.state.data.record.inventoryType = parseInt(e.target.value)} className="form-control input-sm">
                                        <option value="3">LIFO</option>
                                        <option value="2">FIFO</option>
                                        <option value="1">میانگین قیمت</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">ثبت موجودی منفی</div>
                                    <select defaultValue={this.state.data.record.allowNegativeInventory ? 1 : 0} onChange={e => this.state.data.record.allowNegativeInventory = (e.target.value == "1")} className="form-control">
                                        <option value="0">مجاز نیست</option>
                                        <option value="1">مشکلی ندارد</option>
                                    </select>
                                </div>
                            </div>
                            <div className="clear"></div>
                            <div>
                                <span className="acc-txt-10">
                                    <p className="text-muted"><strong>سال مالی</strong></p>
                                </span>
                            </div>
                            
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                    <div className="form-group input-group">
                                        <label className="input-group-addon">واحد پولی <span className="red">*</span></label>
                                        <select defaultValue={this.state.data.record.currencyUnit} onChange={e => this.state.data.record.currencyUnit = parseInt(e.target.value)} className="form-control input-sm">
                                            <option value="1">ریال</option>
                                            <option value="2">تومان</option>
                                        </select>
                                    </div>
                            </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                    <div className="form-group input-group">
                                        <label for="inputTaxRate" className="input-group-addon">نرخ مالیات
                                            <span className="red">*</span></label>
                                    <div className="input-group">
                                        <input defaultValue={this.state.annualTaxPercent} onChange={e => this.state.annualTaxPercent = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid ltr" />
                                            <span className="input-group-addon" id="basic-addon1">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                    <div className="form-group input-group">
                                        <label className="input-group-addon">شروع <span className="red">*</span></label>
                                    <div>
                                        <DatePicker
                                            inputReadOnly={true}
                                            className="form-control input-sm persian-date col-sm-2"
                                            placeholder={"شروع سال مالی"}
                                            isGregorian={false}
                                            showTodayButton={true}
                                            timePicker={false}
                                            onChange={(e) => { this.state.annualStart = e}}
                                            value={this.getFormatedDateForDatePicker(this.state.annualStart)}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                    <div className="form-group input-group">
                                        <label className="input-group-addon">پایان <span className="red">*</span></label>
                                    <div>
                                        <DatePicker
                                            inputReadOnly={true}
                                            className="form-control input-sm persian-date col-sm-2"
                                            placeholder={"پایان سال مالی"}
                                            isGregorian={false}
                                            showTodayButton={true}
                                            timePicker={false}
                                            onChange={(e) => { this.state.annualFinish = e }}
                                            value={this.getFormatedDateForDatePicker(this.state.annualFinish)}
                                        />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                    <div className="form-group input-group">
                                        <label className="input-group-addon">عنوان <span className="red">*</span></label>
                                    <input defaultValue={this.state.annualTitle} onChange={e => this.state.annualTitle = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="40" />
                                    </div>
                                </div>
                            <div className="clear"></div>
                            <div>
                                <span className="acc-txt-10">
                                    <p className="text-muted"><strong>اطلاعات تماس</strong>
                                    </p>
                                </span>
                            </div>
                            <div className="clear"></div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">کشور</div>
                                    <select className="form-control input-sm">
                                        <option selected>ایران</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">استان</div>
                                    <select className="form-control input-sm" defaultValue={this.state.data.record.state} onChange={e => this.state.data.record.state = e.target.value}>
                                        <option value='آذربایجان شرقی'>آذربایجان شرقی</option>
                                        <option value='آذربایجان غربی'>آذربایجان غربی</option>
                                        <option value='اردبیل'>اردبیل</option>
                                        <option value='اصفهان'>اصفهان</option>
                                        <option value='البرز'>البرز</option>
                                        <option value='ایلام'>ایلام</option>
                                        <option value='بوشهر'>بوشهر</option>
                                        <option value='تهران'>تهران</option>
                                        <option value='چهارمحال و بختیاری'>چهارمحال و بختیاری</option>
                                        <option value='خراسان جنوبی'>خراسان جنوبی</option>
                                        <option value='خراسان رضوی'>خراسان رضوی</option>
                                        <option value='خراسان شمالی'>خراسان شمالی</option>
                                        <option value='خوزستان'>خوزستان</option>
                                        <option value='زنجان'>زنجان</option>
                                        <option value='سمنان'>سمنان</option>
                                        <option value='سیستان و بلوچستان'>سیستان و بلوچستان</option>
                                        <option value='فارس'>فارس</option>
                                        <option value='قزوین'>قزوین</option>
                                        <option value='قم'>قم</option>
                                        <option value='کردستان'>کردستان
                                        </option>
                                        <option value='کرمان'>کرمان</option>
                                        <option value='کرمانشاه'>کرمانشاه
                                        </option>
                                        <option value='کهگیلویه و بویر احمد'>کهگیلویه و بویر احمد</option>
                                        <option value='گلستان'>گلستان
                                        </option>
                                        <option value='گیلان'>گیلان</option>
                                        <option value='لرستان'>لرستان
                                        </option>
                                        <option value='مازندران'>مازندران</option>
                                        <option value='مرکزی'>مرکزی</option>
                                        <option value='هرمزگان'>هرمزگان</option>
                                        <option value='همدان'>همدان</option>
                                        <option value='یزد'>یزد</option>
                                        <option value=''>انتخاب نشده</option>
                                    </select >
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">شهر</div>
                                    <input defaultValue={this.state.data.record.city} onChange={e => this.state.data.record.city = e.target.value} autocomplete="off" type="text" className="form-control input-sm" onkeydown="preventNumberInput(event)" maxlength="50" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">کدپستی</div>
                                    <input defaultValue={this.state.data.record.postalCode} onChange={e => this.state.data.record.postalCode = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="10" />
                                </div>
                            </div>
                            <div className="clear"></div>
                            <div className="col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">آدرس</div>
                                    <input defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="150" />
                                </div>
                            </div>
                            <div className="clear"></div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">شماره تماس</div>
                                    <input defaultValue={this.state.data.record.tell} onChange={e => this.state.data.record.tell = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="20" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">شماره فکس</div>
                                    <input defaultValue={this.state.data.record.fax} onChange={e => this.state.data.record.fax = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="20" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">وبسایت</div>
                                    <input defaultValue={this.state.data.record.website} onChange={e => this.state.data.record.website = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="100" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <div className="form-group input-group">
                                    <div className="input-group-addon">آدرس ایمیل</div>
                                    <input defaultValue={this.state.data.record.email} onChange={e => this.state.data.record.email = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="100" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center" style={{ "margin-top": "20px" }}>
                    <div className="row">
                        <div className="row">
                            <div className="col-xs-4 text-right">
                            </div>
                            <div className="col-xs-4 text-center">
                            </div>
                            <div className="col-xs-4 text-left">
                                <button name="next" value="next" type="submit" className="btn btn-success btn-sm">ذخیره</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}